import React from 'react';
import Button from '@/components/primitives/button';
import BottomFixed from '@/components/complex/bottom-fixed';
import styles from './styles.module.scss';

interface StepNavigationProps {
  onNext: () => void;
  onPrevious?: () => void;
  nextLabel?: React.ReactNode;
  previousLabel?: string;
  isNextDisabled?: boolean;
  isPreviousDisabled?: boolean;
  isLoading?: boolean;
  aurora?: boolean;
  onHeightChange: (height: number) => void;
}

/**
 * Component for step navigation buttons in a bottom fixed view
 */
const StepNavigation: React.FC<StepNavigationProps> = ({
                                                         onNext,
                                                         onPrevious,
                                                         nextLabel = '다음',
                                                         previousLabel = '이전',
                                                         isNextDisabled = false,
                                                         isPreviousDisabled = false,
                                                         isLoading = false,
                                                         aurora = false,
                                                         onHeightChange,
                                                       }) => {
  return (
    <BottomFixed className={styles.container} onHeightChange={onHeightChange}>
      <div className={styles.buttonGroup}>
        {onPrevious && (
          <Button
            onClick={onPrevious}
            variant="secondary"
            disabled={isPreviousDisabled}
          >
            {previousLabel}
          </Button>
        )}
        <Button
          onClick={onNext}
          rootClassName={styles.flexButton}
          disabled={isNextDisabled || isLoading}
          aurora={aurora}
        >
          {nextLabel}
        </Button>
      </div>
    </BottomFixed>
  );
};

export default StepNavigation;